(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridal"] && !window.DesignMode) return;
  try {
    

  const password = document.querySelector(".password-area").innerHTML;

  const form = document.querySelector(".form-contaienr");
const input = document.querySelector("#password");
const protected = document.querySelector(".protected-content");
  const overlay = document.querySelector(".overlay");

  
form.addEventListener("submit", (e) => {
  e.preventDefault();
  const value = input.value;
  if (value === password) {
    protected.style.display = 'block';
    form.style.display = 'none'
     overlay.style.display = 'none'
  } else {
    alert("Password is incorrect. Please try again.");
  }
  input.value = "";
});

for (let i = 1; i <= 32; i++) {
  const imageUrl = `https://cdn.shopify.com/s/files/1/0718/1683/9451/files/b${i}.png`;
  const img = document.createElement("img");
  img.src = imageUrl;
  document.getElementById("bridal-lookbookContainer").appendChild(img);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !window.DesignMode) return;
  try {
    

for (let i = 1; i <= 48; i++) {
  const imageUrl = `https://cdn.shopify.com/s/files/1/0718/1683/9451/files/${i}.jpg`;
  const img = document.createElement("img");
  img.src = imageUrl;
  document.getElementById("lookbookContainer").appendChild(img);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whole-sale"] && !window.DesignMode) return;
  try {
    

  const password = document.querySelector(".password-area").innerHTML;

  const form = document.querySelector(".form-contaienr");
const input = document.querySelector("#password");
const protected = document.querySelector(".protected-content");
  const overlay = document.querySelector(".overlay");

  
form.addEventListener("submit", (e) => {
  e.preventDefault();
  const value = input.value;
  if (value === password) {
    protected.style.display = 'block';
    form.style.display = 'none'
     overlay.style.display = 'none'
  } else {
    alert("Password is incorrect. Please try again.");
  }
  input.value = "";
});


  for(let i = 49; i <= 93; i++) {
  const imageUrl = `https://cdn.shopify.com/s/files/1/0718/1683/9451/files/${i}.jpg`;
  const img = document.createElement("img");
  img.src = imageUrl;
  document.querySelector(".protected-content").appendChild(img);
}

  


  } catch(e) { console.error(e); }
})();
})();
